import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 justify-between items-center space-x-2" }
const _hoisted_2 = { class: "col-span-2" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  class: "text-base text-gray-900",
  "data-cy": "row-patient-summary-age"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  class: "text-sm text-gray-500",
  "data-cy": "row-patient-summary-deceased-date"
}
const _hoisted_7 = {
  key: 1,
  class: "justify-between space-x-1"
}
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-gray-500",
  "data-cy": "row-patient-summary-sex"
}
const _hoisted_9 = {
  key: 1,
  class: "text-sm text-gray-500",
  "data-cy": "row-patient-summary-sex"
}
const _hoisted_10 = {
  class: "text-sm text-gray-500",
  "data-cy": "row-patient-summary-age"
}
const _hoisted_11 = {
  class: "text-sm font-regular text-gray-500",
  "data-cy": "row-patient-summary-dob"
}
const _hoisted_12 = {
  key: 0,
  class: "flex space-x-2"
}
const _hoisted_13 = { class: "text-sm text-gray-500" }
const _hoisted_14 = { class: "self-end text-sm text-gray-900" }
const _hoisted_15 = { class: "flex space-x-2" }
const _hoisted_16 = { class: "text-sm text-gray-500" }
const _hoisted_17 = {
  class: "self-end text-sm text-gray-900",
  "data-cy": "row-patient-summary-mrn"
}

import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { FEATURES, genderOptions, sexOptions } from '@/constants';
import { getDobFromISOString, getNhsNumberFromPatient } from '@/helpers/patient.helper';
import { Patient } from '@/models';
import { isFeatureFlagEnabled } from '@/helpers/feature-flag.helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'RowPatientSummary',
  props: {
  homeMonitoring: {
    type: String,
    default: '—'
  },
  patient: {
    type: Object as PropType<Patient>,
    required: true
  }
},
  setup(__props) {

const props = __props;

const { t, d } = useI18n();


const tagFeatureFlagEnabled = computed<boolean>(() => isFeatureFlagEnabled(FEATURES.TAGS));
const gender = computed(() => genderOptions().find((option) => option.value === props.patient.sex));
const sex = computed(() => sexOptions().find((option) => option.value === props.patient.sex));
const useGender = computed(() =>
  !!props.patient.gender // store.state.currentOrganisation.uses_gender && props.patient.gender;
);
const nhsNumberFormatted = computed<string>(() => {
  const nhsNumber = getNhsNumberFromPatient(props.patient);
  return nhsNumber ? nhsNumber : t('platform.common.none').toString();
});

const formatDob = (dob: string) => d(getDobFromISOString(dob), 'shortMonth');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.patient.last_name) + ", " + _toDisplayString(__props.patient.first_name), 1)
      ]),
      (__props.patient.deceased_at)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('custom.uhb.patient.deceased-at', { deceasedDate: formatDob(__props.patient.deceased_at) })), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_unref(useGender) && _unref(gender))
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(`${_unref(gender).label}, `), 1))
              : (_unref(sex))
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(`${_unref(sex).label}, `), 1))
                : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('platform.patient.years', { age: __props.patient.age })), 1),
            _createElementVNode("span", _hoisted_11, "(" + _toDisplayString(formatDob(__props.patient.date_of_birth)) + ")", 1)
          ]))
    ]),
    _createElementVNode("div", null, [
      (_unref(tagFeatureFlagEnabled))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('custom.uhb.copd.home-monitoring')), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(__props.homeMonitoring), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('custom.uhb.patient.nhs')), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(nhsNumberFormatted)), 1)
      ])
    ])
  ]))
}
}

})